var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.323748 62.7955C17.5743 63.0233 31.7432 49.2236 31.971 31.973L0.736117 31.5607L0.323748 62.7955Z",
    fill: "#F0F9F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9714 31.9729C32.1992 14.7224 46.3681 0.922661 63.6186 1.15041L63.2063 32.3853L31.9714 31.9729Z",
    fill: "#F0F9F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9731 31.9717C14.7226 31.744 0.922908 17.575 1.15066 0.324478L32.3855 0.736853L31.9731 31.9717Z",
    fill: "#F0F9F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7908 63.6192C63.0185 46.3687 49.2188 32.1998 31.9683 31.972L31.5559 63.2069L62.7908 63.6192Z",
    fill: "#F0F9F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape10);
export default __webpack_public_path__ + "static/media/shape10.4b3ca964786f2b4bb0f5292999de996e.svg";
export { ForwardRef as ReactComponent };